import { render } from "./trumpetspecialServiceNumber.vue?vue&type=template&id=ebf79a38&scoped=true"
import script from "./trumpetspecialServiceNumber.vue?vue&type=script&lang=js"
export * from "./trumpetspecialServiceNumber.vue?vue&type=script&lang=js"

import "./trumpetspecialServiceNumber.vue?vue&type=style&index=0&id=ebf79a38&scoped=true&lang=css"
import "./trumpetspecialServiceNumber.vue?vue&type=style&index=1&id=ebf79a38&lang=css"
script.render = render
script.__scopeId = "data-v-ebf79a38"

export default script